<template>
    <!-- <app-layout> -->

    <div class="mx-auto flex flex-col flex-grow relative">

        <div class="flex w-full justify-between items-center sm:px-6 lg:px-8 h-16 pt-5">

            <div class="flex w-full justify-start items-center">
                <Folders :way="way" ref="folders" :currentFolder="currentFolder"
                    :canEdit="$page.props.canManageSettings" :folders="folders"
                    :plan_secure_folders="plan_secure_folders">
                </Folders>
            </div>

            <div v-if="way == 'sent'" class="flex-shrink-0">
                <div class="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-8 gap-x-12">
                    <div class="hidden md:flex flex-col items-center justify-center"></div>
                    <div class="hidden lg:flex flex-col items-end justify-center text-sm text-gray-500 gap-y-1">
                    </div>
                    <div class="flex flex-col items-center justify-center">
                        <div class="video-item flex flex-col mb-0 w-full">
                            <Upload :way="way" @uploadSuccess="uploadSuccess" />
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!-- <div v-if="!has_installed_snippet || !live_enabled || !plan_live"
                class="flex flex-grow h-full flex-col justify-start items-center relative overflow-y-scroll bg-birdie-dark bg-opacity-70"> -->

        <!-- <div class="mx-auto flex flex-grow bg-blue-500"> -->
        <div class="w-full mx-auto flex flex-grow items-center justify-center max-w-4xl px-10">

            <div v-if="currentFolder">

                <div class="text-center">
                    <span class="mx-auto w-12 h-12 text-gray-400 block">
                        <svg xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 -960 960 960"
                            stroke="none" fill="currentColor">
                            <path
                                d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h240l80 80h320q33 0 56.5 23.5T880-640v400q0 33-23.5 56.5T800-160H160Zm0-80h640v-400H447l-80-80H160v480Zm0 0v-480 480Z" />
                        </svg>
                    </span>
                    <h3 class="mt-2 text-sm font-semibold text-gray-900">This folder is empty</h3>


                </div>

            </div>

            <div v-else-if="way == 'received'" class="w-full">

                <div class="flex flex-col items-center justify-between gap-y-10">

                    <div
                        class="grid grid-cols-2 gap-x-10 p-10 rounded-lg w-full min-h-96 bg-[linear-gradient(to_bottom,_#606E9C,_#3F4D7A)]">

                        <div class="flex flex-col items-start justify-center text-gray-50 text-sm pl-10">

                            <span class="font-bold text-lg">Request Recordings</span>

                            <p class="mt-8">Request screen recordings from customers, so your team can see the
                                issues
                                clearly and
                                resolve them quickly.</p>

                            <p class="mt-8">From ticket forms to auto-replies, macros, and AI bots—Birdie
                                integrates seamlessly into every workflow.</p>

                            <div class="mt-8 grid grid-cols-6 w-full gap-x-3">
                                <div
                                    class="bg-white/20 text-white rounded-xl p-2 flex justify-center items-center aspect-square zendesk">
                                    <svg width="27" height="21" viewBox="0 0 27 21" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M12.7986 6.04421V20.427H0.914062L12.7986 6.04421ZM12.7986 0.884766C12.7986 4.17152 10.142 6.83406 6.86267 6.83406C3.58331 6.83406 0.914062 4.17152 0.914062 0.884766H12.7986ZM14.756 20.427C14.756 17.1402 17.4126 14.4777 20.692 14.4777C23.9712 14.4777 26.6279 17.1402 26.6279 20.427H14.756ZM14.756 15.2676V0.884766H26.6405L14.756 15.2676Z"
                                            fill="white" />
                                    </svg>
                                </div>
                                <div
                                    class="bg-white/20 text-white rounded-xl p-2 flex justify-center items-center aspect-square intercom">
                                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M22.2513 14.0105C22.2489 14.2276 22.161 14.435 22.0067 14.5878C21.8523 14.7405 21.6439 14.8262 21.4267 14.8262C21.2095 14.8262 21.0011 14.7405 20.8467 14.5878C20.6924 14.435 20.6045 14.2276 20.6021 14.0105V6.5944C20.6045 6.37727 20.6924 6.16985 20.8467 6.01709C21.0011 5.86438 21.2095 5.77873 21.4267 5.77873C21.6439 5.77873 21.8523 5.86438 22.0067 6.01709C22.161 6.16985 22.2489 6.37727 22.2513 6.5944V14.0105ZM21.9636 19.1717C21.836 19.2808 18.7815 21.844 13.181 21.844C7.58059 21.844 4.52614 19.2808 4.3987 19.1717C4.23268 19.0293 4.13 18.8268 4.11323 18.6087C4.09653 18.3906 4.16705 18.1749 4.3093 18.0088C4.45132 17.843 4.65328 17.7404 4.87088 17.7233C5.08849 17.7063 5.30398 17.7762 5.4701 17.9178C5.51851 17.9583 8.24616 20.1948 13.1811 20.1948C18.1779 20.1948 20.8633 17.9422 20.89 17.9195C21.2351 17.6231 21.7566 17.663 22.0527 18.009C22.1952 18.175 22.2657 18.3907 22.2488 18.6089C22.2323 18.8268 22.1296 19.0294 21.9636 19.1717ZM4.11073 6.5944C4.11307 6.37725 4.20098 6.16979 4.35536 6.01707C4.50975 5.86434 4.71815 5.77869 4.93532 5.7787C5.15248 5.7787 5.36087 5.86435 5.51526 6.01708C5.66964 6.1698 5.75755 6.37726 5.7599 6.5944V14.0105C5.75756 14.2276 5.66965 14.4351 5.51527 14.5878C5.36088 14.7405 5.15248 14.8262 4.93532 14.8262C4.71815 14.8262 4.50976 14.7405 4.35537 14.5878C4.20099 14.4351 4.11308 14.2276 4.11073 14.0105V6.5944ZM8.2337 4.94524C8.2366 4.72847 8.32475 4.52157 8.47907 4.36932C8.63338 4.21706 8.84145 4.13169 9.05823 4.13169C9.27501 4.13169 9.48308 4.21706 9.63739 4.36932C9.7917 4.52157 9.87986 4.72847 9.88276 4.94524V15.961C9.87946 16.1775 9.79113 16.384 9.63685 16.5359C9.48258 16.6878 9.27474 16.773 9.05823 16.7729C8.84171 16.773 8.63387 16.6878 8.4796 16.5359C8.32532 16.384 8.237 16.1775 8.2337 15.961V4.94524ZM12.3565 4.528C12.3564 4.41971 12.3777 4.31248 12.4192 4.21243C12.4606 4.11238 12.5214 4.02148 12.5979 3.94492C12.6745 3.86836 12.7654 3.80764 12.8655 3.76621C12.9655 3.72478 13.0727 3.70346 13.181 3.70347C13.2893 3.70343 13.3965 3.72473 13.4966 3.76615C13.5966 3.80758 13.6876 3.86832 13.7641 3.9449C13.8407 4.02146 13.9015 4.11237 13.9429 4.21242C13.9843 4.31247 14.0057 4.41971 14.0056 4.528V16.4842C14.0032 16.7014 13.9153 16.9088 13.761 17.0616C13.6066 17.2143 13.3982 17.2999 13.181 17.2998C12.9639 17.2999 12.7555 17.2143 12.6011 17.0616C12.4467 16.9088 12.3588 16.7014 12.3565 16.4842V4.528ZM16.4793 4.94524C16.4818 4.78376 16.5316 4.62657 16.6226 4.49315C16.7136 4.35974 16.8418 4.25598 16.9912 4.19475C17.1406 4.13352 17.3048 4.11752 17.4632 4.14873C17.6217 4.17995 17.7675 4.257 17.8825 4.37033C18.0368 4.5222 18.1252 4.72873 18.1284 4.94524V15.961C18.1252 16.1775 18.0369 16.384 17.8825 16.536C17.7282 16.6878 17.5204 16.7729 17.3039 16.7729C17.0874 16.773 16.8795 16.6879 16.7252 16.5359C16.571 16.384 16.4826 16.1775 16.4793 15.961V4.94524ZM22.4574 0.410156H3.90462C2.19691 0.410156 0.8125 1.79456 0.8125 3.50228V22.055C0.8125 23.7626 2.19691 25.1471 3.90462 25.1471H22.4574C24.1652 25.1471 25.5495 23.7626 25.5495 22.055V3.50228C25.5495 1.79456 24.1652 0.410156 22.4574 0.410156Z"
                                            fill="white" />
                                    </svg>
                                </div>
                                <div
                                    class="bg-white/20 text-white rounded-xl p-2 flex justify-center items-center aspect-square jira">
                                    <svg width="25" height="32" viewBox="0 0 25 32" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_4646_48015)">
                                            <path
                                                d="M14.905 12.9492L23.1767 12.9967C23.4159 12.9978 23.6502 13.0654 23.8532 13.192C24.0563 13.3186 24.2202 13.4991 24.3265 13.7135C24.4329 13.9278 24.4775 14.1675 24.4555 14.4058C24.4334 14.644 24.3456 14.8715 24.2017 15.0627L11.992 31.3528C11.078 30.6721 10.3072 29.8179 9.72353 28.8391C9.13989 27.8603 8.7549 26.776 8.5906 25.6483C8.42629 24.5206 8.48589 23.3715 8.76598 22.2669C9.04607 21.1622 9.54116 20.1236 10.2229 19.2104L14.905 12.9492Z"
                                                fill="url(#paint0_linear_4646_48015)" />
                                            <path
                                                d="M10.2204 19.2104L1.99623 19.159C1.75729 19.1581 1.5233 19.0908 1.32033 18.9647C1.11737 18.8386 0.953401 18.6587 0.846708 18.4449C0.740015 18.2311 0.694787 17.9919 0.716064 17.7539C0.737341 17.5159 0.824287 17.2885 0.967213 17.097L13.0661 0.9375C14.9095 2.31537 16.1303 4.36901 16.4598 6.6468C16.7893 8.92459 16.2007 11.24 14.8233 13.0838L10.2204 19.2104Z"
                                                fill="white" />
                                        </g>
                                        <defs>
                                            <linearGradient id="paint0_linear_4646_48015" x1="14.5774" y1="14.1711"
                                                x2="18.0554" y2="24.6885" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="white" stop-opacity="0.6" />
                                                <stop offset="1" stop-color="white" />
                                            </linearGradient>
                                            <clipPath id="clip0_4646_48015">
                                                <rect width="23.7475" height="30.4153" fill="white"
                                                    transform="translate(0.710938 0.9375)" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                <div
                                    class="bg-white/20 text-white rounded-xl p-2 flex justify-center items-center aspect-square freshdesk">
                                    <svg width="30" height="30" viewBox="0 0 30 30" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <mask id="mask0_4646_48029" style="mask-type:luminance"
                                            maskUnits="userSpaceOnUse" x="0" y="0" width="30" height="30">
                                            <path d="M29.0829 0.679688H0.140625V29.622H29.0829V0.679688Z"
                                                fill="white" />
                                        </mask>
                                        <g mask="url(#mask0_4646_48029)">
                                            <path
                                                d="M14.5666 0.679804H25.4362C25.9165 0.675945 26.3928 0.767766 26.8372 0.949917C27.2817 1.13208 27.6854 1.4009 28.0249 1.74072C28.3643 2.0806 28.6327 2.48461 28.8143 2.92928C28.996 3.37395 29.0873 3.85031 29.0829 4.33061V15.1962C29.0829 23.1653 22.626 29.6221 14.657 29.6221H14.5747C12.6798 29.6238 10.803 29.2519 9.05188 28.5279C7.30065 27.8039 5.70934 26.7419 4.36887 25.4025C3.0284 24.0631 1.96495 22.4727 1.23947 20.7221C0.513958 18.9715 0.140566 17.0952 0.140625 15.2002C0.140625 7.20858 6.58659 0.762112 14.5666 0.679804Z"
                                                fill="white" />
                                            <path
                                                d="M14.5644 7.12695C10.9045 7.12695 7.9375 10.0935 7.9375 13.7538V18.2598C7.9637 19.4659 8.93512 20.4373 10.1412 20.4635H12.0156V15.2873H9.48317V13.8402C9.63693 11.1151 11.8922 8.98334 14.6223 8.98334C17.3523 8.98334 19.6021 11.111 19.7559 13.8402V15.2873H17.1872V20.4671H18.8808V20.5494C18.8628 21.6682 17.9606 22.5709 16.8459 22.5844H14.823C14.6584 22.5844 14.4776 22.6667 14.4776 22.8309C14.4815 22.9213 14.5192 23.0068 14.5832 23.0708C14.6471 23.1347 14.7327 23.1724 14.823 23.1764H16.858C18.3074 23.1674 19.4801 21.9948 19.4891 20.5453V20.3807C19.9732 20.2717 20.4053 20 20.7135 19.6111C21.0216 19.2222 21.1872 18.7393 21.1827 18.2431V13.8402C21.265 10.1076 18.3047 7.13104 14.5558 7.13104L14.5644 7.12695Z"
                                                fill="#3A3A40" />
                                        </g>
                                    </svg>
                                </div>
                                <div
                                    class="bg-[linear-gradient(to_right,_rgba(255,255,255,0.2)_0%,_rgba(255,255,255,0.08)_100%)] text-white rounded-xl p-2 flex justify-center items-center aspect-square helpscout h-auto">
                                    <svg width="33" height="33" viewBox="0 0 27 33" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M12.4956 9.05293C14.789 6.6911 14.789 2.86183 12.4956 0.5L1.8835 11.4287C-0.409896 13.7906 -0.409896 17.6198 1.8835 19.9817L12.4956 9.05293ZM1.90669 32.4144C-0.386702 30.0526 -0.386702 26.2233 1.90669 23.8615L24.5913 0.500005C26.8847 2.86183 26.8847 6.69111 24.5913 9.05293L1.90669 32.4144ZM13.9782 32.5C11.6848 30.1382 11.6848 26.3089 13.9782 23.9471L24.5902 13.0183C26.8836 15.3802 26.8836 19.2094 24.5902 21.5713L13.9782 32.5Z"
                                            fill="#FFFFFF"></path>
                                    </svg>
                                </div>
                                <div
                                    class="bg-[linear-gradient(to_right,_rgba(255,255,255,0.06)_0%,_rgba(255,255,255,0)_100%)] text-white rounded-xl p-2 flex justify-center items-center aspect-square others">
                                    <svg data-slot="icon" class="opacity-30" fill="currentColor" viewBox="0 0 16 16"
                                        xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                        <path
                                            d="M2 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM6.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM12.5 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z">
                                        </path>
                                    </svg>
                                </div>
                            </div>

                        </div>
                        <div class="flex items-center justify-center">
                            <img src="/img/illus-empty-incoming.png" alt="illustration"
                                class="w-3/4 h-auto object-contain" />
                        </div>
                    </div>

                    <inertia-link type="button" v-if="$page.props.canManageSettings && !$page.props.has_integrations"
                        :href="route('settings.helpdesk')"
                        class="rounded-md bg-birdie-green -mx-2 px-3 py-2 text-sm font-semibold text-birdie-dark shadow-sm hover:bg-birdie-green-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-birdie-green-dark w-64 text-center">Connect
                        Helpdesk</inertia-link>

                </div>
            </div>


            <div v-else-if="way == 'my'" class="w-full">

                <div class="flex flex-col items-center justify-between gap-y-10">

                    <div class="grid grid-cols-2 gap-x-10  rounded-lg overflow-hidden w-full min-h-96 bg-gray-900">

                        <div class="flex flex-col items-start justify-center text-gray-50 text-sm pl-20 py-10 px-10">

                            <span class="font-bold text-lg">Record my Screen</span>

                            <p class="mt-8">Record your screen and capture everything developers need—logs,
                                repro
                                steps,
                                and more—in one
                                click.</p>

                            <p class="mt-8">Or just create clear video instructions for your customers.</p>
                        </div>
                        <div class="flex items-end justify-end">
                            <img src="/img/illus-empty-personal.png" alt="illustration"
                                class="w-5/6 h-auto object-contain" />
                        </div>
                    </div>


                    <a href="#" v-if="!extension_loaded" @click.prevent.stop="skipToExtension()"
                        class="rounded-md border-gray-900 bg-gray-900 hover:bg-gray-800 border px-3 py-2 text-sm font-semibold text-gray-100 shadow-sm  focus-visible:outline-none text-left flex w-64 items-center justify-center gap-x-3">
                        <span class="size-5">
                            <svg id="baseSvg" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet"
                                focusable="false"
                                style="pointer-events: none; display: block; width: 100%; height: 100%;"
                                viewBox="0 -960 960 960" fill="currentColor">
                                <g viewBox="0 -960 960 960">
                                    <path
                                        d="M216-135.869q-33.287 0-56.709-23.422-23.422-23.422-23.422-56.709v-172.304q37.609-2 63.218-28.424 25.608-26.424 25.608-63.272t-25.608-63.272q-25.609-26.424-63.218-28.424V-744q0-33.287 23.422-56.709 23.422-23.422 56.709-23.422h161.065q2.631-40.956 31.96-69.315 29.329-28.359 70.75-28.359t70.975 28.199q29.554 28.199 32.185 69.475H744q33.287 0 56.709 23.422 23.422 23.422 23.422 56.709v161.065q40.956 2.631 69.315 31.96 28.359 29.329 28.359 70.75t-28.199 70.975q-28.199 29.554-69.475 32.185V-216q0 33.287-23.422 56.709-23.422 23.422-56.709 23.422H216Zm2.87-83.001h522.26v-522.26H218.87v108.652q42.13 22.63 65.597 63.772 23.468 41.141 23.468 88.706 0 49.01-23.468 90.168Q261-348.674 218.87-327.283v108.413ZM480-480Z">
                                    </path>
                                </g>
                            </svg>
                        </span>
                        Install Free Extension
                    </a>
                    <a href="#" v-else-if="!ongoing_recording" @click.prevent.stop="startRecording()"
                        class="rounded-md border-blue-gradient hover:border-blue-gradient-hover border px-3 py-2 text-sm font-semibold text-gray-100 shadow-sm  focus-visible:outline-none text-left flex w-64 items-center justify-center gap-x-3">
                        <VideoCameraIcon class="size-5 shrink-0" aria-hidden="true" />
                        Record my Screen
                    </a>



                </div>
            </div>
            <div v-else-if="way == 'sent'" class="w-full">
                <div class="flex flex-col items-center justify-between gap-y-10">

                    <div
                        class="grid grid-cols-2 gap-x-10 px-10 py-20 rounded-lg w-full border border-gray-200 bg-gray-50">

                        <div class="col-span-2 flex flex-col items-center justify-center text-gray-900 text-sm pl-10">

                            <span class="font-bold text-lg">Welcome to your team folder!</span>

                            <p class="mt-8 text-center"> This is where your team can build a shared
                                video library.<br />Move recordings from your personal folder to get
                                started.
                            </p>

                        </div>

                    </div>

                    <inertia-link type="button" v-if="$page.props.canManageSettings"
                        :href="route('teams.show', $page.props.user.current_team) + '#invite'"
                        class="rounded-md bg-birdie-blue -mx-2 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-birdie-blue-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-birdie-blue-dark w-64 text-center flex items-center justify-center gap-x-2">Invite
                        your Team
                        <PlusIcon class="size-4" />
                    </inertia-link>

                </div>
            </div>

        </div>



        <div class="flex justify-around h-20 w-full">
            <div class="w-1/4 bg-gray-100 rounded-t-xl h-full">

            </div>
            <div class="w-1/4 bg-gray-100 rounded-t-xl">

            </div>
            <div class="w-1/4 bg-gray-100 rounded-t-xl">

            </div>
        </div>

    </div>
    <!-- </app-layout> -->
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import { VideoCameraIcon } from '@heroicons/vue/24/solid'
import { PlusIcon } from "@heroicons/vue/16/solid";
import VideoSkeleton from '@/Components/UI/VideoSkeleton'
import Upload from '@/Components/Video/Upload'
import Folders from '@/Components/UI/Folders'


export default {
    props: ['way', 'folders', 'currentFolder', 'plan_secure_folders'],
    components: {
        AppLayout, VideoCameraIcon, PlusIcon, VideoSkeleton, Upload, Folders
    },
    layout: AppLayout, // keep layout in place avoid refreshing it
    data() {
        return {
            app_name: this.$page.props.app_name,
            extension_loaded: window.extension_loaded,
            ongoing_recording: false
        }
    },
    created() {
        this.extension_loaded = window.extension_loaded || false;
        document.addEventListener('EXTENSION_RESPONSE', this.extension_loaded_listener);
    },
    beforeUnmount() {
        document.removeEventListener('EXTENSION_RESPONSE', this.extension_loaded_listener);
    },
    mounted() {
        // this.EventBus.emit("start.call", "hello")
        document.dispatchEvent(new CustomEvent('GET_EXTENSION_STATE', {
            detail: {}
        }));
    },
    methods: {
        extension_loaded_listener(event) {
            this.extension_loaded = true;
            window.extension_loaded = true;
            if (event.detail?.ongoingRecording ?? false) {
                this.ongoing_recording = true
            }
        },
        uploadSuccess() {
            const routename = this.way == 'my' ? 'library.personal' : 'library.team'
            this.$inertia.get(route(routename));
        },
        startRecording() {
            document.dispatchEvent(new CustomEvent('START_RECORDING_ASKED', {
                detail: {}
            }));
        },
        skipToExtension() {
            window.location.href = "https://chromewebstore.google.com/detail/birdie/glkfmfjeafnooojgeobbhdjhdejocoap"
        },
    },
    computed: {
        title() {
            if (this.way == 'my') {
                return 'Personal'
            } else if (this.way == 'sent') {
                return 'Team'
            } else if (this.way == 'search') {
                return 'Search results'
            } else if (this.way == 'received') {
                return 'Incoming'
            }
            return ''
        },

    }
}
</script>
